<a *ngIf="displayStyle === 'link'" (click)="contactUs()" >{{ label }}</a>
<button *ngIf="displayStyle === 'button'" mat-flat-button (click)="contactUs()" color="accent">{{ label }}</button>
